"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isPromiseLike(obj) {
    return (!!obj &&
        (typeof obj === "object" || typeof obj === "function") &&
        typeof obj.then === "function");
}
exports.default = isPromiseLike;
